import { service } from '@ember/service';
import { formatUrl } from 'frontend-utils/utils/url/format-url';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

export interface BulkUserUpdate {
  products?: string[];
  role?: string;
  user_id: number;
}

export interface BulkApplyBody {
  add_products?: string[];
  remove_products?: string[];
  role?: string;
}

export interface BulkApplyFilters {
  product?: string;
  q?: string;
  role?: string;
}

export default class SubscriptionUserAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  // @ts-expect-error: Property 'buildURL' in type 'SubscriptionUserAdapter' is not assignable to the same property in base type 'ApplicationAdapter'.
  buildURL(
    modelName: string,
    id: string,
    snapshot: unknown,
    requestType: string,
  ): string {
    if (requestType === 'deleteRecord') {
      const subscriptionId = this.hotelAndMarketService.hotel.id;
      return `${this.host}/${APIGATEWAY}/subscriptions/${subscriptionId}/users/${id}/`;
    }

    // @ts-expect-error: Expected 3 arguments, but got 4.
    return super.buildURL(modelName, id, snapshot, requestType);
  }

  async bulkApply(
    subscriptionId: string,
    body: BulkApplyBody,
    options: { excludedUserIds: number[]; filters: BulkApplyFilters },
  ): Promise<void> {
    const params: Record<string, string | number[]> = {
      exclude: options.excludedUserIds,
    };
    if (options.filters.role) {
      params['filter[role]'] = options.filters.role;
    }
    if (options.filters.product) {
      params['filter[product]'] = options.filters.product;
    }
    if (options.filters.q) {
      params['filter[q]'] = options.filters.q;
    }

    const url = formatUrl(
      `/${APIGATEWAY}/subscriptions/${subscriptionId}/users/bulk/`,
      params,
      this.host,
    );
    await this.ajax(url, 'PATCH', { data: body });
  }

  async bulkUpdate(
    subscriptionId: string,
    users: BulkUserUpdate[],
  ): Promise<void> {
    const url = `${this.host}/${APIGATEWAY}/subscriptions/${subscriptionId}/users/`;
    await this.ajax(url, 'PATCH', { data: { users } });
  }
}
